import { render, staticRenderFns } from "./ModalShippingBulk.vue?vue&type=template&id=1bca628d&scoped=true&"
import script from "./ModalShippingBulk.vue?vue&type=script&lang=js&"
export * from "./ModalShippingBulk.vue?vue&type=script&lang=js&"
import style0 from "./ModalShippingBulk.vue?vue&type=style&index=0&id=1bca628d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca628d",
  null
  
)

export default component.exports